import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/avia73.pro/layouts/default.vue").then(m => m.default || m))
}